import { render, staticRenderFns } from "./ProvidersButton.vue?vue&type=template&id=457af40b&scoped=true"
import script from "./ProvidersButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProvidersButton.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProvidersButton.vue?vue&type=style&index=0&id=457af40b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457af40b",
  null
  
)

export default component.exports